import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login    from './pages/Login';
import Layout   from './components/Layout';
import Dashboard      from './pages/Dashboard';
import Patients       from './pages/Patients';
import Subscriptions  from './pages/Subscriptions';
import Classes        from './pages/Classes';
import Stats          from './pages/Stats';

function Shell() {
  const { user, loading } = useAuth();
  const [page, setPage]     = useState('dashboard');
  const [pageParams, setPageParams] = useState(null);

  if (loading) {
    return (
      <div style={{
        height: '100vh', display: 'grid', placeItems: 'center',
        background: 'var(--warm-white)', color: 'var(--stone)', fontSize: 14,
      }}>
        Cargando…
      </div>
    );
  }

  if (!user) return <Login />;

  function navigate(id, params = null) {
    setPage(id);
    setPageParams(params);
  }

  return (
    <Layout current={page} onNav={navigate}>
      {page === 'dashboard'     && <Dashboard onNav={navigate} />}
      {page === 'patients'      && <Patients params={pageParams} />}
      {page === 'subscriptions' && <Subscriptions />}
      {page === 'classes'       && <Classes />}
      {page === 'stats'         && <Stats />}
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
